import React from 'react';
import { IconSVG } from '../../../components';
import { getAccentColor } from '../../../utils';
import { PartnerContent } from 'packages/smart-home-support/partner';

const accentColor = getAccentColor();

const WhatsCovered: React.FC = () => (
  <PartnerContent
    Sprint={
      <IconSVG width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="5" width="13" height="12" fill={accentColor} />
        <path
          d="M19.527 5.126L10.527 0.126C10.224 -0.042 9.85799 -0.042 9.55499 0.126L0.554992 5.126C0.237992 5.303 0.0419922 5.637 0.0419922 6C0.0419922 6.694 0.155993 23 10.042 23C19.928 23 20.042 6.694 20.042 6C20.042 5.637 19.845 5.303 19.527 5.126ZM10.38 16.816L5.29199 13L6.79199 11L9.70299 13.184L13.982 6.338L16.102 7.663L10.38 16.816Z"
          fill="black"
        />
      </IconSVG>
    }
  >
    <IconSVG width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3203 25.1875C14.3203 25.4635 14.0963 25.6875 13.8203 25.6875C13.5443 25.6875 13.3203 25.4635 13.3203 25.1875V20.6875H11.3203V25.1875C11.3203 26.5665 12.4423 27.6875 13.8203 27.6875C15.1983 27.6875 16.3203 26.5665 16.3203 25.1875V24.6875H14.3203V25.1875Z"
        fill="black"
      />
      <path
        d="M13.3192 9.7385L13.3202 8.6875C13.3202 8.1345 12.8722 7.6875 12.3202 7.6875C11.7672 7.6875 11.3202 8.1345 11.3202 8.6875L11.3192 9.7385C6.29422 10.2375 2.36622 14.4585 2.32422 19.6045C3.65122 18.4165 5.39822 17.6875 7.32022 17.6875C9.24522 17.6875 10.9952 18.4195 12.3232 19.6115C13.6502 18.4215 15.3962 17.6875 17.3202 17.6875C19.2422 17.6875 20.9882 18.4165 22.3162 19.6045C22.2742 14.4565 18.3442 10.2365 13.3192 9.7385Z"
        fill="black"
      />
      <path
        d="M22.6484 7.95471L18.9414 4.18838L20.3554 2.75174L22.6484 5.08145L26.9414 0.719727L28.3554 2.15636L22.6484 7.95471Z"
        fill={accentColor}
      />
    </IconSVG>
  </PartnerContent>
);

export default WhatsCovered;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/WhatsCovered.tsx